import { ContentEditor, Image, Slider } from '~/components'
import type { PortableTextBlock } from '@portabletext/react'
import type { SanityRefWithAlt } from '~/types'
import clsx from 'clsx'

export type USPSliderItem = {
  _key: string
  icon?: SanityRefWithAlt
  content?: PortableTextBlock[]
}

interface USPSliderProps {
  items?: USPSliderItem[]
}

export default function USPSlider({ items = [] }: USPSliderProps) {
  if (!items.length) return null

  const count = items.length

  const perPageTablet = Math.min(2, count)
  const perPageDesktop = Math.min(4, count)

  return (
    <div className="container py-4">
      <Slider
        className="splide-usp"
        options={{
          autoplay: count > 1,
          type: count > 1 ? 'loop' : 'slide',
          gap: '0.75rem',
          interval: 4000,
          speed: 600,
          drag: count > 1,
          pagination: false,
          arrows: false,
          breakpoints: {
            768: {
              perPage: perPageTablet,
              gap: '1rem',
              drag: count > 1,
            },
            1024: {
              perPage: perPageDesktop,
              gap: '1.5rem',
              autoplay: false,
              drag: false,
            },
          },
        }}
      >
        {items.map((item, i) => {
          const { _key, icon, content } = item
          const isLast = i === count - 1

          return (
            <div
              key={_key}
              className={clsx(
                'flex h-full items-center justify-center',
                !isLast && 'lg:border-r-2 lg:border-gray-300 lg:pr-6'
              )}
            >
              <div className="inline-flex items-center gap-3 px-3">
                {icon?.asset && (
                  <div className="flex size-8 shrink-0 items-center justify-center">
                    <Image
                      image={icon}
                      customSize={64}
                      className="size-full object-contain"
                    />
                  </div>
                )}
                {content?.length && (
                  <div className="text-sm leading-snug [&>p]:m-0 [&>p]:leading-snug">
                    <ContentEditor content={content} />
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </Slider>
    </div>
  )
}
